var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatJpg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 13c1.05 0 1.628.417 1.847 1.39a.5.5 0 0 1-.976.22c-.111-.496-.27-.61-.871-.61-.752 0-1 .504-1 2 0 1.494.25 2 1 2 .465 0 .753-.264.9-.846l.033-.155L15 17a.5.5 0 0 1-.492-.41l-.008-.09a.5.5 0 0 1 .41-.492L15 16h1.5a.5.5 0 0 1 .499.536C16.89 18.058 16.277 19 15 19c-1.496 0-2-1.024-2-3 0-1.978.504-3 2-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H.5a.5.5 0 0 0-.5.5v23a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.146-.354l-6-6A.5.5 0 0 0 13.5 0Zm-.208.999 5.707 5.707v16.293h-18v-22h12.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0a.5.5 0 0 1 .492.41L14 .5l-.001 5.499L19.5 6a.5.5 0 0 1 .492.41L20 6.5a.5.5 0 0 1-.41.492L19.5 7h-6a.5.5 0 0 1-.492-.41L13 6.5v-6a.5.5 0 0 1 .5-.5ZM10.75 13a1.75 1.75 0 0 1 .143 3.494l-.143.006-.751-.001.001 2a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.492-.41L9 18.499V13.5a.5.5 0 0 1 .41-.492L9.5 13h1.25Zm-.751 2.499.751.001a.75.75 0 0 0 .102-1.493L10.75 14l-.751-.001v1.5ZM6.5 13a.5.5 0 0 1 .492.41L7 13.5V17a2 2 0 1 1-4 0 .5.5 0 1 1 1 0 1 1 0 0 0 1.993.117L6 17v-3.5a.5.5 0 0 1 .5-.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatJpg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/format-jpg.3f81236b4ec038dd131212f80cb74c0c.svg";